import { createEffect, createMemo, createSignal, onMount, splitProps } from "solid-js";

export type Props = IntrinsicElement<"div"> & {
  _elements: {
    main: JSX.Element;
  };
  _class?: {
    main?: string;
    children?: string;
  };
  children: JSX.Element | JSX.Element[];
};

function isOutOfViewport(elem) {
  // Get element's bounding
  var bounding = elem.getBoundingClientRect();

  // Check if it's out of the viewport on each side
  var out = {} as any;
  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
  out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
  out.any = out.top || out.left || out.bottom || out.right;
  out.all = out.top && out.left && out.bottom && out.right;

  return out;
}

export default function Tooltip(props: Props) {
  const [local, others] = splitProps(props, ["children", "_elements", "_class"]);
  const [$show, setShow] = createSignal(false);
  const [$options_direction, setOptionsDirection] = createSignal("down" as "up" | "down");
  let ref = undefined as HTMLDivElement;
  let main_ref = undefined as HTMLDivElement;
  let children_ref = undefined as HTMLDivElement;

  createEffect(() => {
    const show_options = $show();
    if (!show_options) {
      setOptionsDirection("down");
      return;
    }
    const isOut = isOutOfViewport(children_ref);
    // console.log("is out :: ", children_ref, " :: ", isOut);
    if (isOut.any) {
      // At least one side of the element is out of viewport
      // console.log("element ::", options_ref, " :: is out");
      setOptionsDirection("up");
    }
  });

  onMount(() => {
    ref.onmouseleave = (e) => setShow(false);
    ref.ontouchend = (e) => setShow(false);
    main_ref.onmouseenter = (e) => setShow(true);
    main_ref.ontouchstart = (e) => setShow(true);
  });

  return (
    <div
      {...others}
      ref={(r) => {
        if (r == undefined) {
          return;
        }
        ref = r;
      }}
      class={
        "relative flex flex-col w-full h-full" + " " + (others.class ?? "")
        //
      }
    >
      <div
        ref={(ref) => {
          if (ref == undefined) {
            return;
          }
          main_ref = ref;
        }}
        class={"tooltip-main flex flex-row w-fit h-fit !z-5 " + " " + (local._class?.main ?? "")}
      >
        {local._elements.main ?? "tooltip needs a _elements.main prop"}
      </div>
      <div
        ref={(ref) => {
          if (ref == undefined) {
            return;
          }
          children_ref = ref;
        }}
        class={
          "tooltip-children flex flex-col min-w-full w-fit h-fit self-center !z-10" +
          " " +
          ($show() ? "absolute" : "!hidden") +
          " " +
          ($options_direction() === "down" ? "top-106%" : "bottom-106%") +
          " " +
          (local._class?.children ?? "")
        }
      >
        {local.children}
      </div>
    </div>
  );
}
